import { HttpInterceptorFn } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';

import { BaseUrlService } from './base-url.service';

export const BASE_PATH = new InjectionToken<string>('urlInterceptor.BASE_PATH');

export const urlInterceptor: HttpInterceptorFn = (req, next) => {
  const isAbsoluteUrl = /^([a-z]+:)?\/\//i.test(req.url); // starts with http://, xy://, or // (protocol-relative URL)
  if (!isAbsoluteUrl) {
    const baseUrlSetByInput = inject(BaseUrlService).baseUrlSetByInput();
    const apiBasePath = inject(BASE_PATH, { optional: true }) ?? '';

    const isApiRequest = !req.url.startsWith('/assets/') && req.url !== '/version.json';
    let url = req.url;
    if (isApiRequest) {
      url = joinUrl(apiBasePath, req.url); // e.g. concat '/api/customer-data-frontend' and '/v1/user'
    }
    if (baseUrlSetByInput) {
      url = joinUrl(baseUrlSetByInput, url); // e.g. concat 'http://xy.yz/awp/' and '/api/customer-data-frontend/v1/user'
    }
    const apiReq = req.clone({ url: url });
    return next(apiReq);
  } else {
    return next(req);
  }
};

function joinUrl(first: string, second: string) {
  return first.replace(/\/$/, '') + '/' + second.replace(/^\//, '');
}
